import React from "react";
import {
    LockKeyOpen,
    ChartBar,
    Lifebuoy,
    Chats,
    CalendarCheck,
    Tray,
    Student,
    TreeStructure,
    Translate,
    Ticket,
    ChalkboardTeacher,
    Hash,
    ArrowSquareIn,
    Broadcast,
    Wrench
} from '@phosphor-icons/react'


export const supportIconKeys = [
    'Admin',
    'Statistikk',
    'Support',
    'Forum',
    'Inbox',
    'Booking',
    'Akademi',
    'Datavask',
    'Translations Primus',
    'Billettskanner',
    'Skole',
    'Kanaler',
    'PrimusImport',
    'Kulturio Remote',
    'Config'
].sort((a, b) => a.localeCompare(b))

export const AppServiceIcon = ({appName, size=28}) => {
    const iconArgs = {
        weight: "duotone",
        color: "#5F7077",
        size: size,
        style: {
            minWidth: `${size}px`
        },
        role: "graphics-document",
    }

    const icons = {
        'Admin': <LockKeyOpen {...iconArgs} />,
        'Statistikk': <ChartBar {...iconArgs} />,
        'Support': <Lifebuoy {...iconArgs} />,
        'Forum': <Chats {...iconArgs} />,
        'Inbox': <Tray {...iconArgs} />,
        'Booking': <CalendarCheck {...iconArgs} />,
        'Akademi': <Student {...iconArgs} />,
        'Datavask': <TreeStructure {...iconArgs} />,
        'Translations Primus': <Translate {...iconArgs} />,
        'Billettskanner': <Ticket {...iconArgs} />,
        'Skole': <ChalkboardTeacher {...iconArgs} />,
        'Kanaler': <Hash {...iconArgs} />,
        'PrimusImport': <ArrowSquareIn {...iconArgs} />,
        'Kulturio Remote': <Broadcast {...iconArgs} />,
        'Config': <Wrench {...iconArgs} />
    }

    return icons[appName]
}